module.exports = __webpack_public_path__ + "assets/img/1-whos-this-for-min.470812b8.jpg";